import { Controller } from "@hotwired/stimulus"

// Toggles Resident/Vendor searchable selects on the New Support Message form.
export default class extends Controller {
  static targets = ["residentPanel", "vendorPanel", "residentSelect", "vendorSelect"]

  connect() {
    // Ensure only the visible panel's hidden input is submitted.
    if (this.vendorPanelTarget.classList.contains("hidden")) {
      this.enableResident()
    } else {
      this.enableVendor()
    }
  }

  showResident() {
    this.residentPanelTarget.classList.remove("hidden")
    this.vendorPanelTarget.classList.add("hidden")
    this.resetSelect(this.vendorSelectTarget)
    this.enableResident()
  }

  showVendor() {
    this.vendorPanelTarget.classList.remove("hidden")
    this.residentPanelTarget.classList.add("hidden")
    this.resetSelect(this.residentSelectTarget)
    this.enableVendor()
  }

  enableResident() {
    this.inputFor(this.residentSelectTarget).disabled = false
    this.inputFor(this.vendorSelectTarget).disabled = true
  }

  enableVendor() {
    this.inputFor(this.vendorSelectTarget).disabled = false
    this.inputFor(this.residentSelectTarget).disabled = true
  }

  inputFor(selectElement) {
    return selectElement.querySelector('[data-searchable-select-target="input"]')
  }

  resetSelect(selectElement) {
    const controller = this.application.getControllerForElementAndIdentifier(
      selectElement,
      "searchable-select"
    )
    if (controller) {
      controller.reset()
    } else {
      const input = this.inputFor(selectElement)
      const search = selectElement.querySelector('[data-searchable-select-target="search"]')
      if (input) input.value = ""
      if (search) search.value = ""
    }
  }
}
